import React, { useState } from 'react';
import { WebSocketClientProps } from '../types';

const WebSocketClient: React.FC<WebSocketClientProps> = ({ 
  connected, 
  messages, 
  onConnect, 
  onDisconnect,
  keycloak
}) => {
  const [connecting, setConnecting] = useState(false);

  const handleConnect = async () => {
    if (!keycloak || !keycloak.token) {
      console.error('Keycloak not initialized or no token available');
      alert('Please login first before connecting to WebSocket');
      return;
    }

    setConnecting(true);
    try {
      await onConnect(keycloak);
    } catch (error) {
      console.error('Failed to connect:', error);
      alert(`Failed to connect to WebSocket: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setConnecting(false);
    }
  };

  return (
    <div className="websocket-section">
      <h3>🔌 WebSocket Client</h3>
      <div className="ws-controls">
        {!connected ? (
          <button 
            className="btn btn-connect" 
            onClick={handleConnect}
            disabled={connecting}
          >
            {connecting ? 'Connecting...' : 'Connect to WebSocket'}
          </button>
        ) : (
          <button className="btn btn-disconnect" onClick={onDisconnect}>
            Disconnect
          </button>
        )}
      </div>

      {messages.length > 0 && (
        <div className="ws-messages">
          <h4>Messages:</h4>
          <div className="message-list">
            {messages.slice(-10).map((msg, idx) => (
              <div key={idx} className={`message message-${msg.type}`}>
                <span className="message-time">{msg.time.toLocaleTimeString()}</span>
                <span className="message-text">{msg.text}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WebSocketClient;
